var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"red","rx":"12"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#fff","d":"m14.74 9.5-3.548 3.549L9.26 11.12l-.759.759 2.692 2.692 4.308-4.307-.76-.765Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }